<template>
  <div>
    <!-- 面包屑导航 -->
    <div class="flex-spc-x fixed">
      <el-breadcrumb separator-class="el-icon-arrow-right" style="postion:fixed">
        <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
        <el-breadcrumb-item :to="{ path: '/setting/setting' }">系统设置</el-breadcrumb-item>
        <el-breadcrumb-item>预约配置</el-breadcrumb-item>
      </el-breadcrumb>
      <el-link type="primary" style="margin-right:220px" @click="tosetting()"><i class="el-icon-back"></i> 返回</el-link>
    </div>

    <div>
       <div class="flex-spc-x" style="width:100%;padding-top:30px;padding-bottom:50px">
            <el-table
                             :data="SettingList"
                             tooltip-effect="dark"
                             border
                             stripe
                             style="width: 100%">
                            <el-table-column type="index" label="序号" align="center" width=""></el-table-column>
                             <el-table-column label="名称" prop="name"></el-table-column>
                            <el-table-column  label="有效值"  >
                                 <template slot-scope="scope">
                                  <span v-if="scope.row.isEdit=='0'">  {{scope.row.effective}}</span>
                                  <el-input placeholder="请输入"  v-if="scope.row.isEdit=='1' && (scope.row.sType=='6' || scope.row.sType=='7' || scope.row.sType=='8'|| scope.row.sType=='9'|| scope.row.sType=='11'|| scope.row.sType=='12'|| scope.row.sType=='13'|| scope.row.sType=='14'|| scope.row.sType=='15')" v-model="scope.row.info" ></el-input>  
                                   <el-select v-model="SelectDay"  v-if="scope.row.isEdit=='1' && scope.row.sType=='2'"  >
                                    <el-option label="当天" value="0"></el-option>
                                    <el-option label="提前一天" value="1"></el-option>
                                    <el-option label="提前两天" value="2"></el-option>
                                    <el-option label="提前三天" value="3"></el-option>
                                    <el-option label="提前四天" value="4"></el-option>
                                    <el-option label="提前五天" value="5"></el-option>
                                    <el-option label="提前六天" value="6"></el-option>
                                    <el-option label="提前七天" value="7"></el-option>
                                </el-select> 
                                <el-select v-model="SelectDay"  v-if="scope.row.isEdit=='1' && scope.row.sType=='5'"  >
                                    <el-option label="当天" value="0"></el-option>
                                    <el-option label="提前一天" value="1"></el-option>
                                    <el-option label="提前两天" value="2"></el-option>
                                    <el-option label="提前三天" value="3"></el-option>
                                    <el-option label="提前四天" value="4"></el-option>
                                    <el-option label="提前五天" value="5"></el-option>
                                    <el-option label="提前六天" value="6"></el-option>
                                    <el-option label="提前七天" value="7"></el-option>
                                </el-select> 
                                <el-input placeholder="请输入"  v-if="scope.row.isEdit=='1' && scope.row.sType=='2' && SelectDay=='0' " v-model="scope.row.info" ></el-input>  
                                <el-input placeholder="请输入"  v-if="scope.row.isEdit=='1' && scope.row.sType=='5' && SelectDay=='0'" v-model="scope.row.info" ></el-input>  
                                   <el-select v-model="SelectDay"  v-if="scope.row.isEdit=='1' && scope.row.sType=='10'"  @change="changeV" >
                                    <el-option label="当天" value="0"></el-option>
                                    <el-option label="提前一天" value="1"></el-option>
                                    <el-option label="提前两天" value="2"></el-option>
                                    <el-option label="提前三天" value="3"></el-option>  
                                    <el-option label="提前四天" value="4"></el-option>
                                    <el-option label="提前五天" value="5"></el-option>
                                    <el-option label="提前六天" value="6"></el-option>
                                    <el-option label="提前七天" value="7"></el-option>
                                </el-select> 
                                 <el-select v-model="Selecttimes"  v-if="scope.row.isEdit=='1' && scope.row.sType=='10' && SelectDay =='0'"  >
                                      <el-option label="30" value="30"></el-option>
                                      <el-option label="45" value="45"></el-option>
                                      <el-option label="60" value="60"></el-option>
                                      <el-option label="90" value="90"></el-option>
                                      <el-option label="120" value="120"></el-option>
                                      <el-option label="150" value="150"></el-option>
                                      <el-option label="180" value="180"></el-option>
                                 </el-select>
                               
                                   <el-select v-model="Selecttimes"  v-if="scope.row.isEdit=='1' && scope.row.sType=='10' && SelectDay !='0'"  >
                                    <el-option label="05:00" value="05:00"></el-option>
                                    <el-option label="06:00" value="06:00"></el-option>
                                    <el-option label="07:00" value="07:00"></el-option>
                                    <el-option label="08:00" value="08:00"></el-option>
                                    <el-option label="09:00" value="09:00"></el-option>
                                    <el-option label="10:00" value="10:00"></el-option>
                                    <el-option label="11:00" value="11:00"></el-option>
                                    <el-option label="12:00" value="12:00"></el-option>
                                    <el-option label="13:00" value="13:00"></el-option>
                                    <el-option label="14:00" value="14:00"></el-option>
                                    <el-option label="15:00" value="15:00"></el-option>
                                    <el-option label="16:00" value="16:00"></el-option>
                                    <el-option label="17:00" value="17:00"></el-option>
                                    <el-option label="18:00" value="18:00"></el-option>
                                    <el-option label="19:00" value="19:00"></el-option>
                                    <el-option label="20:00" value="20:00"></el-option>
                                    <el-option label="21:00" value="21:00"></el-option>
                                    <el-option label="22:00" value="22:00"></el-option>
                                </el-select> 
                                 <el-select v-model="Selecttimesmt"  v-if="scope.row.isEdit=='1' && scope.row.sType=='16'"  >
                                    <el-option label="00:30" value="00:30"></el-option>
                                    <el-option label="01:00" value="01:00"></el-option>
                                    <el-option label="01:30" value="01:30"></el-option>
                                    <el-option label="02:00" value="02:00"></el-option>
                                    <el-option label="02:30" value="02:30"></el-option>
                                    <el-option label="03:00" value="03:00"></el-option>
                                    <el-option label="03:30" value="03:30"></el-option>
                                    <el-option label="04:00" value="04:00"></el-option>
                                    <el-option label="04:30" value="04:30"></el-option>
                                    <el-option label="05:00" value="05:00"></el-option>
                                    <el-option label="05:30" value="05:30"></el-option>
                                    <el-option label="06:00" value="06:00"></el-option>
                                    <el-option label="06:30" value="06:30"></el-option>
                                    <el-option label="07:00" value="07:00"></el-option>
                                    <el-option label="07:30" value="07:30"></el-option>
                                    <el-option label="08:00" value="08:00"></el-option>
                                    <el-option label="08:30" value="08:30"></el-option>
                                    <el-option label="09:00" value="09:00"></el-option>
                                    <el-option label="09:30" value="09:30"></el-option>
                                    <el-option label="10:00" value="10:00"></el-option>
                                    <el-option label="10:30" value="10:30"></el-option>
                                    <el-option label="11:00" value="11:00"></el-option>
                                    <el-option label="11:30" value="11:30"></el-option>
                                    <el-option label="12:00" value="12:00"></el-option>
                                    <el-option label="12:30" value="12:30"></el-option>
                                    <el-option label="13:00" value="13:00"></el-option>
                                    <el-option label="13:30" value="13:30"></el-option>
                                    <el-option label="14:00" value="14:00"></el-option>
                                    <el-option label="14:30" value="14:30"></el-option>
                                    <el-option label="15:00" value="15:00"></el-option>
                                    <el-option label="15:30" value="15:30"></el-option>
                                    <el-option label="16:00" value="16:00"></el-option>
                                    <el-option label="16:30" value="16:30"></el-option>
                                    <el-option label="17:00" value="17:00"></el-option>
                                    <el-option label="17:30" value="17:30"></el-option>
                                    <el-option label="18:00" value="18:00"></el-option>
                                    <el-option label="18:30" value="18:30"></el-option>
                                    <el-option label="19:00" value="19:00"></el-option>
                                    <el-option label="19:30" value="19:30"></el-option>
                                    <el-option label="20:00" value="20:00"></el-option>
                                    <el-option label="20:30" value="20:30"></el-option>
                                    <el-option label="21:00" value="21:00"></el-option>
                                    <el-option label="21:30" value="21:30"></el-option>
                                    <el-option label="22:00" value="22:00"></el-option>
                                    <el-option label="22:30" value="22:30"></el-option>
                                    <el-option label="23:00" value="23:00"></el-option>
                                    <el-option label="23:30" value="23:30"></el-option>
                                </el-select> 
                                <el-select v-model="SelectCDtimes"  v-if="scope.row.isEdit=='1' && scope.row.sType=='18' "  >
                                    <el-option label="15" value="15"></el-option>
                                     <el-option label="30" value="30"></el-option>
                                     <el-option label="45" value="45"></el-option>
                                 </el-select>
                            </template>
                            </el-table-column>
                            <el-table-column label="操作" align="center" width="">
                            <template slot-scope="scope">
                             <el-button type="text" @click="editSeetingClick(scope.row)" v-if="(scope.row.Ison && scope.row.isEdit=='0' && scope.row.info !='')||scope.row.sType=='10'||scope.row.sType=='2' ||scope.row.sType=='5'" >修改</el-button>
                             <el-button type="primary" size="medium" @click="editsaverClick(scope.row)" v-if="scope.row.Ison && scope.row.isEdit=='1' ">保存</el-button>
                             <el-button type="default"  @click="editcancelClick(scope.row)" v-if="scope.row.Ison && scope.row.isEdit=='1' ">取消</el-button>
                                <el-switch 
                                     v-model="scope.row.Ison"
                                     on-color="#00A854"
                                     on-text="启动"
                                     on-value="1"
                                     off-color="#F04134"
                                     off-text="禁止"
                                     off-value="0"
                                     @change="changeSwitch(scope.row)">
                                </el-switch>
                            </template>
                        </el-table-column>
                        </el-table>
        
    </div>
    </div>
    </div> 
</template>
<script>
import CropperImage from "../../components/CropperImage";
import Pagination from '../../components/Pagination'
export default {
  data() {
    return {
 
    DianList:[],
    SelectStoresID:localStorage.getItem("StoresID"),
    tableLoading:false,
    overtype:0,
    Selecttimesmt:"",
    SelectDay:"0",
    Selecttimes:"",
    SelectCDtimes:"",
    BirthdayNumber:'',
    SettingList:[],
        WZYGName:'',
    WZHYName:'',
    WZXMName:'',
    WZPBName:'',
      formInline: {
        page: 1,
        limit: 10,
        varLable: '',
        varName: '',
        token: localStorage.getItem('logintoken')
      }
    
    }
  },
  // 注册组件
  components: {
    Pagination,
     CropperImage,
  },
  /**
   * 数据发生改变
   */

  /**
   * 创建完毕
   */
  created() {

    this.WZYGName = localStorage.getItem('WZYGName')
    this.WZHYName = localStorage.getItem('WZHYName')
    this.WZXMName = localStorage.getItem('WZXMName')
    this.WZPBName = localStorage.getItem('WZPBName')

    this.getList()
    
  },

  /**
   * 里面的方法只有被调用才会执行
   */
  methods: {
    changeV(){
      if(this.SelectDay == 0){

          this.Selecttimes = '1'  

      } else {
        
        this.Selecttimes = '05:00'

      }
     
    },
      tosetting(){
        this.$router.go(-1)
      },
      getList(){

       this.tableLoading = true
       var data = { SelectStoresID:this.$route.params.id,
          token: localStorage.getItem("token"),
          StoresID:localStorage.getItem("StoresID"),
    
      }
     
      
        var that = this
      this.ajax('getAllStting.aspx',JSON.stringify(data),"POST",function(res){
          if (res.orsuccess == "1") {
                that.tableLoading = false
                that.SettingList = res.data
            for (let i = 0; i < res.data.length; i++) {
                        
                        if(res.data[i].Ison =='1'){
                        that.SettingList[i].Ison = true;

                        }else{
                        that.SettingList[i].Ison = false;

                        }
                    }
          } 

      })
  
  
    },
    changeSwitch(val){
                let ison = 0;
               if(val.Ison){
                   ison =1;
               }else{
                   ison =0;
               }

              
               this.editSttingIson(val.ID , ison);
            }, editSttingIson(SttingID,Ison){

       this.tableLoading = true
       var data = { SelectStoresID:this.$route.params.id,
          token: localStorage.getItem("token"),
          StoresID:localStorage.getItem("StoresID"),
          SttingID:SttingID,
          Ison:Ison
         }
     
      
        var that = this
         this.ajax('editSttingIson.aspx',JSON.stringify(data),"POST",function(res){
          if (res.orsuccess == "1") {
                that.tableLoading = false
                that.getList();
                 that.$message({
                type: "success",
                message: res.Msg,duration:2000,
              });
              // if()
                }else{
                   that.getList();

                     that.$message({
                type: "error",
                message: res.Msg,duration:2000,
              });

                 }

      })

            },

            
            editSeetingClick(val){
                val.isEdit = '1';

                    
                if(val.sType == '16'){
                   this.Selecttimesmt = val.info;
               }
                 if(val.sType == '18'){
                   this.SelectCDtimes = val.info;
               }
                 if(val.sType == '10'){
                   this.Selecttimes = val.info;
               }
             },editsaverClick(val){
                
                 if(val.sType == '10'){
                this.editSttinginfodays(val.ID,this.Selecttimes,this.SelectDay);
               }else if(val.sType == '2'){
                this.editSttinginfodaysNew(val.ID,val.info,this.SelectDay);
               }else if(val.sType == '5'){
                this.editSttinginfodaysNew(val.ID,val.info,this.SelectDay);
               }else if(val.sType == '16'){
                 this.editSttinginfo(val.ID,this.Selecttimesmt);
               }else if(val.sType == '18'){
                 this.editSttinginfo(val.ID,this.SelectCDtimes);
               }
               else{
                 this.editSttinginfo(val.ID,val.info);
               }
                
              },editcancelClick(val){
                val.isEdit = '0';
             }, editSttinginfo(SttingID,info){
                 this.tableLoading = true
       var data = { SelectStoresID:this.$route.params.id,
          token: localStorage.getItem("token"),
          StoresID:localStorage.getItem("StoresID"),
          SttingID:SttingID,
          info:info
         }
     
      
        var that = this
         this.ajax('editSttinginfo.aspx',JSON.stringify(data),"POST",function(res){
          if (res.orsuccess == "1") {
                that.tableLoading = false
                that.getList();
                 that.$message({
                type: "success",
                message: res.Msg,duration:2000,
              });
 
                }else{
                     that.$message({
                type: "error",
                message: res.Msg,duration:2000,
              });
                  
                 }

      })

             }, editSttinginfodaysNew(SttingID,info,days){
                 this.tableLoading = true
       var data = { SelectStoresID:this.$route.params.id,
          token: localStorage.getItem("token"),
          StoresID:localStorage.getItem("StoresID"),
          SttingID:SttingID,
          info:info,
          days:days
         }
     
      
        var that = this
         this.ajax('editSttinginfodaysNew.aspx',JSON.stringify(data),"POST",function(res){
          if (res.orsuccess == "1") {
                that.tableLoading = false
                that.getList();
                 that.$message({
                type: "success",
                message: res.Msg,duration:2000,
              });
 
                }else{
                     that.$message({
                type: "error",
                message: res.Msg,duration:2000,
              });
                  
                 }

      })

             }, editSttinginfodays(SttingID,info,days){
                 this.tableLoading = true
       var data = { SelectStoresID:this.$route.params.id,
          token: localStorage.getItem("token"),
          StoresID:localStorage.getItem("StoresID"),
          SttingID:SttingID,
          info:info,
          days:days
         }
     
      
        var that = this
         this.ajax('editSttinginfodays.aspx',JSON.stringify(data),"POST",function(res){
          if (res.orsuccess == "1") {
                that.tableLoading = false
                that.getList();
                 that.$message({
                type: "success",
                message: res.Msg,duration:2000,
              });
 
                }else{
                     that.$message({
                type: "error",
                message: res.Msg,duration:2000,
              });
                  
                 }

      })

             }
   
  }
}
</script>
 


// WEBPACK FOOTER //
// src/views/setting/SettingInfo.vue